export default defineNuxtPlugin(() => {
  if (import.meta.server || !useIsFeatureFlagEnabled('gtm')) return

  const { beforeEach } = useRouter()
  const { reset } = useTrackingFieldSingleton()

  beforeEach(reset)
})
